import { render, staticRenderFns } from "./realEstates.vue?vue&type=template&id=5b00ba8a&scoped=true&"
import script from "./realEstates.vue?vue&type=script&lang=js&"
export * from "./realEstates.vue?vue&type=script&lang=js&"
import style0 from "./realEstates.vue?vue&type=style&index=0&id=5b00ba8a&lang=scss&scoped=true&"
import style1 from "./realEstates.vue?vue&type=style&index=1&id=5b00ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00ba8a",
  null
  
)

export default component.exports